import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

@Injectable({
  providedIn: 'root'
})
export class IntegrantesFacultadesService {

  constructor(private servi: ServiceService) { }

  public getIntegrantes(id) {
    return this.servi.get('IntegrantesFacultades/GetIntegrantes/'+id);
  }

  public Guardarintegrante(formintegrantes) {
    return this.servi.post(`IntegrantesFacultades/PostGuardar/`, formintegrantes);
  }

}
